package net.keinekekse.app

import kotlinx.browser.document
import kotlinx.browser.window
import net.keinekekse.app.books.isbnScanResultPath
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLSelectElement
import org.w3c.dom.Option
import org.w3c.dom.asList

fun main() {
    window.asDynamic().renderScanner = ::renderScanner
    window.asDynamic().checkIfOptionExists = ::checkIfOptionExists
    window.asDynamic().toggleField = ::toggleField

    window.asDynamic().Alpine = Alpine.asDynamic().default
//    console.log("Alpine loaded ", Alpine)
//    Alpine.asDynamic().default.start() // muss im body passieren

// Beispielcode
//    // event handling for htmx
//    var rowCount = 1
//    document.addEventListener("htmx:beforeSwap", {
//        document.getElementById("total-count")?.innerHTML = "Total: ${(++rowCount) * 10}"
//    })
//    // Scroll to the bottom of the page after adding content
//    document.addEventListener("htmx:afterSwap", {
//        val scrollHeight = document.body?.scrollHeight ?: 0
//        window.scrollTo(0.0, scrollHeight.toDouble())
//    })
}

/*
   Die fn wird in den Namensraum <project>.<package> veröffentlicht
   -> web.net.keinekekse.app
   Wenn die fn ohne den Rattenschwanz aufgerufen werden soll, muss sie
   in main() so exportiert werden:
     js("window.renderScanner = renderScanner")
   oder
     window.asDynamic().renderScanner = ::renderScanner

   Des Weiteren benötigt sie ein DOM-Element (id="reader"), daher ist es sinnvoll,
   sie erst bei geladenem DOM auszuführen:
       document.addEventListener('DOMContentLoaded', function () {
           renderScanner();
       })

   Beim Import von htmx wird der gesamte Import an ein Objekt namens "default"
   gehängt. Da sich auch Ktor auf diesen Import verlässt, ist es hier besser,
   zu kapitulieren und das Objekt als htmx.asDynamic().default.<whatever> zu
   verwenden.
 */
@OptIn(ExperimentalJsExport::class)
@JsExport
fun renderScanner(scanTarget: String = "reader") {
    // Ausgabebereich fürs Ergebnis zurücksetzen
    document.getElementById("scan-result")?.innerHTML =
        "<p>Bitte Barcode vor die Kamera halten...</p>"

    // Scanner öffnen
    val config = js("{ fps: 10, qrbox: { width: 300, height: 180 } }")
    val scanner = Html5QrcodeScanner(scanTarget, config, /*debug*/ false)

    // Ergebnis verarbeiten
    scanner.render({ decodedText, _ ->
        scanner.clear()
        document.getElementById("scan-result")?.innerHTML =
            "<p>Hole Daten für ISBN: $decodedText</p>"
        console.log("Scanned: $decodedText")
//        console.log("htmx: ", htmx)
        htmx.asDynamic().default.ajax(
            "GET",
            "${isbnScanResultPath}/" + js("encodeURIComponent(decodedText)"),
            js("{ target: '#scan-result', swap: 'innerHTML' }")
        )
    }, { errorMessage ->
        console.log("Error: $errorMessage")
    })
}

@OptIn(ExperimentalJsExport::class)
@JsExport
fun checkIfOptionExists(selectName: String, thisInput: HTMLInputElement, message: String) {
    console.log(thisInput.value)
    val select: HTMLSelectElement = document.getElementById(selectName) as HTMLSelectElement
    val optArray: List<Option> = select.options.asList() as List<Option>
    thisInput.setCustomValidity("")
    optArray.find { it.text.equals(thisInput.value, ignoreCase = true) }?.let {
        thisInput.setCustomValidity(message)
    }
}

@OptIn(ExperimentalJsExport::class)
@JsExport
fun toggleField(hideObj: HTMLInputElement, showObj: HTMLInputElement) {
    hideObj.disabled = true
    hideObj.style.display = "none"
    showObj.disabled = false
    showObj.style.display = "inline"
    showObj.focus()
}
